<template>
  <div id="basic-view" class="container">
    <!-- 插槽 -->
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "basic",
  components: {},
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss">
</style>
<!-- <style src="../styles/index.css" scoped /> -->
<style lang="scss" scoped>
/* PC版样式111 */
.container {
  width: 768px;
  min-width: 300px;
  /* PC版容器宽度为768像素 */
  margin: auto;
}

@media screen and (max-width: 768px) {
  /* 手机/平板电脑版样式 */
  .container {
    width: 96%;
    /* 手机/平板电脑版容器宽度为屏幕宽度的90% */
  }
}
#basic-view {
  ::v-deep {
    .title {
      text-align: center;
    }

    .pannel {
      background-color: #f5f5f5;
      margin-bottom: 10px;
    }
    .pannel-center {
      text-align: center;
    }

    .tip-msg {
      padding: 0 10px;
      margin-bottom: 10px;
      font-size: 0.75em;
    }

    .pay-time {
      margin-bottom: 10px;
    }

    .pannel-btn {
      text-align: center;
      margin-bottom: 10px;
    }

    .pay-flow {
      padding: 10px;
    }
    .pay-flow p.no {
      font-size: 1em;
      padding: 2px 0;
    }

    .pannel-simp {
      padding: 10px;
    }
    .attention {
      font-size: 0.85em;
    }

    table.details {
      width: 100%;
    }
    table.details tr td:nth-child(1) {
      padding: 5px 10px;
      text-align: left;
    }
    table.details tr td:nth-child(2) {
      padding-right: 10px;
      text-align: right;
    }

    button.btn,
    a.btn {
      background-color: #4caf50;
      border: none;
      color: white;
      text-align: center;
      text-decoration: none;
      display: inline-block;
      border-radius: 3px;
      padding: 0.58em;
    }
    button.copy {
      background-color: rgb(255, 151, 106);
      padding: 6px 10px;
      margin-left: 4px;
      margin-top: 4px;
      margin-right: 4px;
      margin-bottom: 4px;
      font-size: 0.75em !important;
    }
    button.switch {
      padding: 4px 8px;
    }
    button.btn-disabled,
    a.btn-disabled {
      background-color: grey;
    }
    button.btn-alip,
    a.btn-alip {
      background-color: rgb(22, 119, 255);
    }
    button.btn-weix,
    a.btn-weix {
      background-color: #4caf50 !important;
    }
    button.btn-other,
    a.btn-other {
      background-color: #4caf50 !important;
    }
    button.btn-n1,
    a.btn-n1 {
      background-color: #573393;
    }
    button.video {
      border: 2px solid;
      border-color: rgb(22, 119, 255);
      color: rgb(22, 119, 255);
      background-color: white;
      width: 100%;
      padding: 0.4em;
    }

    .bankcard-amount {
      margin-bottom: 0.95em;
      font-size: 0.95em;
      color: #a30f0f;
    }
    .bankcard-owner {
      margin-top: 0.95em;
      margin-bottom: 0.95em;
      font-size: 0.75em;
    }
    .bankcard-account {
      margin-bottom: 0.95em;
      font-size: 0.9em;
    }
    button.bankcard-copy,
    a.bankcard-copy {
      background-color: rgb(22, 119, 255);
      padding: 6px 10px;
      margin-top: 4px;
      margin-bottom: 4px;
      font-size: 0.75em !important;
      width: 50%;
    }
    a.down {
      border: 2px solid;
      border-color: rgb(22, 119, 255);
      padding: 3px 0;
      color: rgb(22, 119, 255);
      background-color: white;
      font-size: 0.75em !important;
      width: 50%;
    }
    a.down-zise {
      border-color: #573393;
      color: #573393;
    }

    .vdf-modal {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.7);
      z-index: 199;
    }

    .vdf-modal-content {
      background-color: #fff;
      border-radius: 10px;
      width: 80%;
      max-width: 400px;
      margin: 100px auto;
      padding: 20px;
      text-align: center;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
      position: relative;
    }

    .vdf-phone-container {
      display: flex;
      justify-content: center;
      gap: 5px;
      align-items: center;
    }

    .vdf-phone-number {
      text-align: center;
      border: none !important;
      border-radius: 0 !important;
      border-bottom: 1px solid #ccc !important;
      padding: 10px 2px !important;
      font-size: 28px;
      font-weight: bold;
    }

    .vdf-modal input {
      width: 90%;
      padding: 10px;
      margin-top: 10px;
      border: 1px solid #ccc;
      border-radius: 5px;
      margin: auto;
    }

    /* 复制的表格 */
    .infoContainer {
      height: 100%;
      width: 100%;
      background-color: #e1e1e1;
      display: flex;
      flex-direction: row;
      justify-content: center; /* 水平居中 */
      align-items: center; /* 垂直居中 */
    }
    .infoContainer > .items1 {
      text-align: left;
      padding: 0 0.4em;
    }
    .infoContainer > .items2 {
      flex: 4;
      text-align: right;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    .infoContainer > .items3 {
      text-align: left;
    }
  }
}
</style>
